/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SlashMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTElEQVR4nN2VvU7EMAzHO/AxA2LhCUA8RNeKO8c+pJx9SKydgAnBxF424F1gYOTEGyDeAFgOdjghUA4i2muPNGkXiBSpiv/2z46tJor+zdJaLyjiU0B+VCQfIRuIHxRJZmKVAMYQGliVd1YCNMlcTW+Up6oKPALwdf4agKQ/rWkCGAPIpvWL43hOEd+1BgCUs4JfTw6qdIEAfiHaXbE+nc7OEiCPWgMA8V7Rhy9mab0BgHKfpum81Xe3B+uA/NYeoCdJQY9y9ZveCwDEl3kt4mDLlZAPYFxnLIMBUHMsgwCA8qy1XrYa823O3APBo7qA/bwGkM8B5RVQjpSStchnVY2luW9rJ+INM5aAfOwVeCaApG9tSZIsmh/cxPadOZDcOnuBPPwp/+uxcDYv0Xp1khDy0NkLkhvvBweQTxo8mZK5KgHk9y7yYRDkT65PsoZtHlV1/8wAAAAASUVORK5CYII=)
 */
export const SlashMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8.67c.12 0 .17-.33.06-.39A2.87 2.87 0 0 1 12 19a3 3 0 0 1 3-3h6.5a.5.5 0 0 0 .5-.5V5a3 3 0 0 0-3-3H5Zm12.79 3.37a.25.25 0 0 0-.22-.37h-3.13a.75.75 0 0 0-.66.38L6.21 18.63c-.1.16.03.37.22.37h3.13c.27 0 .52-.14.66-.38l7.57-13.25Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
